import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-price_tag_man",
  "use": "icon-price_tag_man-usage",
  "viewBox": "0 0 27 16",
  "content": "<symbol viewBox=\"0 0 27 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-price_tag_man\"><rect fill=\"#d1f4ed\" height=\"16\" rx=\"3\" width=\"27\" /><path d=\"m6.97 3.71h5.9l-.36 2.59h-5.9zm-.63 2.82h6.36l-.32 2.33h-6.36zm1.34 4.62-1.76-.91.02-.16h2.29l.91.46 1.3-.55v-.12s-4.51 0-4.51 0l.12-.83h6.26l-.22 1.46-1.64.67 1.9.92h-2.8l-.61-.3-.74.3h-2.8l2.28-.95zm-3.64-7.17-.25-.5h1.88l-1.21 8.62h-1.56l1.14-8.11zm-1.87 5.74.79-4.5h.76l-.73 4.5zm3.09-2.04.32-2.46h.78l-.32 2.46zm3.46-3h2.2l.05-.31h-2.2zm2.08.94.04-.3h-2.2l-.04.3zm-1.7 2.46h.43l.1-.77h-.43zm2.07-.77h-.42l-.1.77h.41zm-3.55.77h.37l.1-.77h-.36zm14.54-2.08.85 2.21h-1.88l-.08-.22-6.71.24.14-1.07 1.31-1.75h-1.64l.14-1.08h3.62l.06-.4-.4-.46h2.83l-.12.85h3.59l-.14 1.08h-5.64l-1.22 1.63 3.77-.11-.36-.94h1.88zm-.98 2.41-.3 2.11h1.73l.48-.43-.25 1.8h-4.32l.49-3.48zm-3.36-.01-2.28 3.52h-2.29l2.27-3.52z\" fill=\"#1a1a1a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/price_tag_man.svg
// module id = usi/
// module chunks = 87